import { diService, type IDi } from "@/backend/domains/di";
import { TsyringeDi } from "@/backend/domains/di/infrastructure/tsyringe";

import {
  PaymentsCheckoutForm,
  PaymentsProvider,
  PaymentsScript,
  PaymentSystemStore,
} from "../domains/payment-system";
import {
  TiptopCheckoutForm,
  tiptopCommonStore,
  TiptopProvider,
  TiptopScript,
} from "../domains/payment-system/infrastructure/tiptop";

//

export type Tokens =
  typeof di extends IDi<infer R> ? (keyof R extends string ? keyof R : never) : never;

//

export const di = diService.createInstance(TsyringeDi, ({ useValue }) => ({
  PaymentSystemProvider: useValue<PaymentsProvider>(TiptopProvider),
  PaymentSystemScript: useValue<PaymentsScript>(TiptopScript),
  PaymentSystemStore: useValue<PaymentSystemStore>(tiptopCommonStore),
  PaymentsCheckoutForm: useValue<PaymentsCheckoutForm>(TiptopCheckoutForm),
}));
